var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M70.0607 13.0685C70.6464 12.4827 70.6464 11.5329 70.0607 10.9472L60.5147 1.40121C59.9289 0.815424 58.9792 0.815424 58.3934 1.40121C57.8076 1.987 57.8076 2.93674 58.3934 3.52253L66.8787 12.0078L58.3934 20.4931C57.8076 21.0789 57.8076 22.0286 58.3934 22.6144C58.9792 23.2002 59.9289 23.2002 60.5147 22.6144L70.0607 13.0685ZM0 13.5078H69V10.5078H0V13.5078Z","fill":"#002EBB"}));
}

Arrow.defaultProps = {"width":"71","height":"24","viewBox":"0 0 71 24","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
